import type { Task, TaskId } from '@bigint-project/core';

/**
 * 依 `collapsedTaskIds` 過濾出可見任務清單。
 * 假設 `tasks` 已依大綱順序(前序走訪,父在子之前)排列。
 */
export function getVisibleTasks(
  tasks: readonly Task[],
  collapsedTaskIds: readonly TaskId[],
): readonly Task[] {
  const collapsed = new Set<TaskId>(collapsedTaskIds);
  const hiddenAncestors = new Set<TaskId>();
  const visible: Task[] = [];

  for (const task of tasks) {
    const parentHidden = task.parentId !== null && hiddenAncestors.has(task.parentId);
    if (parentHidden) {
      hiddenAncestors.add(task.id);
      continue;
    }
    visible.push(task);
    if (collapsed.has(task.id)) {
      hiddenAncestors.add(task.id);
    }
  }

  return visible;
}
